export default {
	init() {
        $("#searchMobile").click(function() {
            $(".searchMobile").fadeToggle();
        });
        
		$('.couponButton').attr('disabled',true);
		$('#coupon_code').keyup(function(){
			if($(this).val().length !=0) {
				$('.couponButton').attr('disabled', false);
			} else {
				$('.couponButton').attr('disabled', true);        
			}
		});

		if( $('.filterArchive').length ) {
			var s = $(".filterArchive");
			var pos = s.position();
			$(window).scroll(function () {
				var windowpos = $(window).scrollTop();
				if (windowpos >= pos.top) {
					s.addClass("stickFilter");
				} else {
					s.removeClass("stickFilter");
				}
			});
		}

        $('a.readMore').click(function () {
			$(this).siblings('.excerpt').slideToggle(0);
			$(this).siblings('.whole-post').slideToggle(0);
			$(this).hide();
			$("a.readLess").show();
			return false;
		});

		$('a.readLess').click(function () {
			$(this).siblings('.excerpt').slideToggle(0);
			$(this).siblings('.whole-post').slideToggle(0);
			$(this).hide();
			$("a.readMore").show();
			return false;
		});

		$(document).on('click','.js-menu_toggle.closed',function(e){
			e.preventDefault(); $('.list_load, .list_item').stop();
			$(this).removeClass('closed').addClass('opened');
			$('.side_menu').css({ 'left':'0px' });
			var count = $('.list_item').length;
			$('.list_load').slideDown( (count*.6)*100 );
			$('.list_item').each(function(i){
				var thisLI = $(this);
				setTimeout(function(){
					thisLI.css({
						'opacity':'1',
						'margin-left':'0',
					});
				},100*i);
			});
		});

		$(document).on('click','.js-menu_toggle.opened',function(e){
			e.preventDefault(); $('.list_load, .list_item').stop();
			$(this).removeClass('opened').addClass('closed');
			$('.side_menu').css({ 'left':'-250px' });
			$('.list_item').css({
				'opacity':'0',
				'margin-left':'-20px',
			});
			$('.list_load').slideUp(300);
		});

		$('.sliderBestsellers').slick({
			dots: true,
			arrows: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			speed: 400,
			prevArrow:"<button type='button' class='fa-prev slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>",
			nextArrow:"<button type='button' class='fa-next slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 2,
				},
			}, {
				breakpoint: 580,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: false,
				},
			}],
		});

		$('.headerBottom').addClass('original').clone().insertAfter('.headerBottom').addClass('cloned').css('position','fixed').css('top','0').css('margin-top','0').css('background','#efefe7').css('z-index','9999').removeClass('original').hide();
		setInterval(stickIt, 10);
		function stickIt() {
			var orgElementPos = $('.original').offset();
			var orgElementTop = orgElementPos.top;               
			if ($(window).scrollTop() >= (orgElementTop)) {    
				var orgElement = $('.original');
				var coordsOrgElement = orgElement.offset();
				var leftOrgElement = coordsOrgElement.left;  
				var widthOrgElement = orgElement.css('width');
				$('.cloned').css('left',leftOrgElement+'px').css('top',0).css('width',widthOrgElement).show();
				$('.original').css('visibility','hidden');
			} else {
				$('.cloned').hide();
				$('.original').css('visibility','visible');
			}
		}

		if ($('#back-to-top').length) {
			var scrollTrigger = 100,
				backToTop = function () {
					var scrollTop = $(window).scrollTop();
					if (scrollTop > scrollTrigger) {
						$('#back-to-top').addClass('show');
					} else {
						$('#back-to-top').removeClass('show');
					}
			};
			backToTop();
			$(window).on('scroll', function () {
				backToTop();
			});
			$('#back-to-top').on('click', function (e) {
				e.preventDefault();
				$('html,body').animate({
					scrollTop: 0,
				}, 700);
			});
		}

		if ($('#back-to-top-product').length) {
			var scrollTrigger2 = 600,
				backToTop2 = function () {
					var scrollTop = $(window).scrollTop();
					if (scrollTop > scrollTrigger2) {
						$('#back-to-top-product').addClass('show');
					} else {
						$('#back-to-top-product').removeClass('show');
					}
			};
			backToTop2();
			$(window).on('scroll', function () {
				backToTop2();
			});
			$('#back-to-top-product').on('click', function (e) {
				e.preventDefault();
				$('html,body').animate({
					scrollTop: 0,
				}, 700);
			});
		}

		if (document.getElementById('schakel-filter')) {
			document.getElementById('schakel-filter').addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('.filter-col').classList.toggle('open');
			});
		}

		if (document.getElementById('schakel-filter2')) {
			document.getElementById('schakel-filter2').addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('.filter-col').classList.toggle('open');
			});
		}

		$('#query').keyup(function () {
			if ($(this).val() == '') {
				$('#searchsubmit').prop('disabled', true);
			} else {
				$('#searchsubmit').prop('disabled', false);
			}
		}).keyup();
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js